import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { motion } from "framer-motion";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import "./AppoinymentPage.css";
import configServ from "../../services/config";
import toast, { Toaster } from "react-hot-toast";
import { Autocomplete, TextField } from "@mui/material";
import AppointmentTable from "./AppointmentTable";
import CircularProgress from "@mui/material/CircularProgress";

import dayjs from "dayjs";

const AppointmentPage = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    patient_id: [],
    doctor_id: "",
    date: "",
    time: [],
    bulk_slot: false,
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [doctorAvailableDays, setDoctorAvailableDays] = useState([]);
  const [practitionersName, setPractitionersName] = useState([]);
  const [patientsName, setPatientsName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // --------------------

  const [appointments, setAppointments] = useState([]);
  const [loadingg, setLoadingg] = useState(false);
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("patient");
  const [currentPage, setCurrentPage] = useState(0); // zero-based for MUI TablePagination
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const fetchAppointments = async () => {
    setLoadingg(true);
    try {
      const dataToSend = {
        search,
        searchBy,
        page: currentPage + 1, // backend is 1-based
        limit: perPage,
        endDate: endDate,
        startDate: startDate,
      };
      const res = await configServ.getAllAppointments(dataToSend);
      setAppointments(res.data);
      setTotal(res.total);
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoadingg(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, [search, currentPage, perPage, searchBy, startDate, endDate]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  // ----------------

  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
    clearForm();
    if (!openDialog) setIsEdit(false); // reset edit state on open
  };

  const clearForm = () => {
    setFormData({
      patient_id: [],
      doctor_id: "",
      date: "",
      time: [],
      bulk_slot: false,
    });
    setSelectedDate(null);
    setAvailableTimeSlots([]);
    setDoctorAvailableDays([]);
    setIsEdit(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (
      !formData.bulk_slot &&
      formData.patient_id.length !== formData.time.length
    ) {
      toast.error("Please select the same number of time slots as patients.");
      setLoading(false);
      return;
    }
    if (!formData.doctor_id) {
      toast.error("Please select a doctor.");
      setLoading(false);
      return;
    }

    if (!formData.date) {
      toast.error("Please select a date.");
      setLoading(false);
      return;
    }

    try {
      const res = await configServ.bookMultipleAppointmentsAsAdmin(formData);
      if (res.success) {
        toast.success("Appointment saved successfully!");
        clearForm();
        setOpenDialog(false);
        fetchAppointments();
      } else {
        toast.error(res.message || "Failed to save appointment.");
      }
    } catch (error) {
      toast.error("An error occurred while saving the appointment.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formData, [name]: value };
    setFormData(updatedForm);

    if (name === "doctor_id") {
      fetchAppointmentDays(value);
      setSelectedDate(null);
      setAvailableTimeSlots([]);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formattedDate = format(date, "yyyy-MM-dd");
    setFormData((prev) => ({ ...prev, date: formattedDate }));

    if (formData.doctor_id) {
      fetchAppointmentSlots(formData.doctor_id, formattedDate);
    }
  };

  const isDayAvailable = (date) => {
    const day = format(date, "EEEE"); // Full day name
    return doctorAvailableDays.includes(day);
  };

  const dayClassName = (date) => {
    const day = format(date, "EEEE");
    return doctorAvailableDays.includes(day)
      ? "available-day"
      : "unavailable-day";
  };

  const fetchAppointmentDays = async (doctorId) => {
    try {
      const res = await configServ.getDoctorAvailableDays({
        doctor_id: doctorId,
      });
      if (res.success) {
        setDoctorAvailableDays(res.data || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAppointmentSlots = async (doctorId, pickDate) => {
    try {
      const res = await configServ.getDoctorSlots({
        doctor_id: doctorId,
        date: pickDate,
      });
      if (res.success) {
        setAvailableTimeSlots(res.data.slots || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchPractitionersName = async () => {
      try {
        const res = await configServ.getAllPractitioners();
        if (res.success) {
          setPractitionersName(res.data || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchPractitionersName();
  }, []);

  useEffect(() => {
    const fetchPatientsName = async () => {
      try {
        const res = await configServ.getAllStandardPatients();
        if (res.success) {
          setPatientsName(res.data || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchPatientsName();
  }, []);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // console.log("Start Date:", startDate);
  // console.log("End Date:", endDate);

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Create Appointment"}
        handlePopup={handleClickOpen}
        create={openDialog}
      />

      {openDialog && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            padding: 20,
            borderRadius: "10px",
            border: "1px solid #ddd",
            marginTop: 10,
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            {isEdit ? "Edit" : "Create"} Appointment
          </Typography>

          <Grid container spacing={2}>
            {/* Select Patient */}
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                multiple
                options={patientsName}
                disableCloseOnSelect
                getOptionLabel={(option) => option.fname}
                filterSelectedOptions
                value={patientsName.filter((p) =>
                  formData.patient_id.includes(p.id)
                )}
                onChange={(e, value) =>
                  setFormData((prev) => ({
                    ...prev,
                    patient_id: value.map((v) => v.id),
                  }))
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.fname}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Select Patients" size="small" />
                )}
                size="small"
                sx={{ backgroundColor: "white" }}
              />
            </Grid>

            {/* Select Doctor */}
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Doctor</InputLabel>
                <Select
                  name="doctor_id"
                  value={formData.doctor_id}
                  onChange={handleChange}
                  sx={{ backgroundColor: "white" }}
                >
                  {practitionersName.map((doc) => (
                    <MenuItem key={doc.id} value={doc.id}>
                      {doc.fname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Select Date */}

            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                fullWidth
                size="small"
                style={{ zIndex: 10, position: "relative" }}
              >
                {/* <Typography fontSize={13} fontWeight={500} sx={{ mb: 0.5 }}>
                  Select Date
                </Typography> */}
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  minDate={new Date()}
                  filterDate={isDayAvailable}
                  dayClassName={dayClassName}
                  placeholderText="Select available date"
                  className="custom-datepicker"
                  dateFormat="yyyy-MM-dd"
                />
              </FormControl>
            </Grid>

            {/* Select Time Slot */}
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                multiple
                options={availableTimeSlots} // ✅ Show all slots
                disableCloseOnSelect
                getOptionLabel={(option) => option.time}
                filterSelectedOptions
                value={availableTimeSlots.filter((slot) =>
                  formData.time.includes(slot.time)
                )}
                onChange={(e, selectedOptions) =>
                  setFormData((prev) => ({
                    ...prev,
                    time: selectedOptions.map((slot) => slot.time),
                  }))
                }
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={{
                      pointerEvents:
                        option.status !== "available" ? "none" : "auto",
                      opacity: option.status !== "available" ? 0.5 : 1,
                    }}
                  >
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      disabled={option.status !== "available"} // ❌ Disable if not available
                    />
                    {option.time}{" "}
                    {option.status === "booked"
                      ? "(Booked)"
                      : option.status === "past"
                      ? "(Past)"
                      : ""}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Time Slots"
                    size="small"
                  />
                )}
                size="small"
                sx={{ backgroundColor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="bulk_slot"
                    checked={formData.bulk_slot || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        bulk_slot: e.target.checked,
                      }))
                    }
                  />
                }
                label="Bulk Slot"
              />
            </Grid>

            {/* Actions */}
            <Grid item xs={12} container spacing={2} justifyContent="flex-end">
              <Grid item xs={6} sm={2}>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={clearForm}
                  startIcon={<RotateLeftIcon />}
                >
                  Reset
                </Button>
              </Grid>
              <Grid item xs={6} sm={2}>
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  startIcon={<SaveIcon />}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size="20px" />
                  ) : isEdit ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </motion.div>
      )}

      <AppointmentTable
        handleSearch={handleSearch}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        loading={loadingg}
        total={total}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        setCurrentPage={setCurrentPage}
        search={search}
        appointments={appointments}
        perPage={perPage}
        currentPage={currentPage}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startDate={startDate}
        endDate={endDate}
        setSearch={setSearch}
      />
    </>
  );
};

export default AppointmentPage;
